module.exports = __webpack_public_path__ + "static/img/emoji_6.42dfd848.png";